import { lazy } from "react"
import { Root } from "src/shared/components"
import PermissionRoute from "../permission-route"

// ---- Accounting routes ----
const AccountingHome = lazy(() => import("src/modules/accounting/Home"))
const ChartOfAccounts = lazy(() => import("src/modules/accounting/chart-of-account/pages/ChartOfAccountsList"))
const AccountSubtype = lazy(() => import("src/modules/accounting/account-subtype/Pages"))
const AssetClass = lazy(() => import("src/modules/accounting/pages/AssetClass"))
const AssetMaster = lazy(() => import("src/modules/accounting/pages/AssetMaster"))
const BankAccountList = lazy(() => import("src/modules/accounting/bank-account/pages/BankAccountList"))
const SourceModule = lazy(() => import("src/modules/accounting/source-module/pages/sourceModuelList"))
const AccountsReceivable = lazy(() => import("src/modules/accounting/AccountsReceivable/pages/AccountReceivableList"))
const AccountsPayable = lazy(() => import("src/modules/accounting/AccountsPayable/pages/AccountPayableList"))
const CashAccountList = lazy(() => import("src/modules/accounting/cash-account/pages/CashAccountList"))
const CashDepositList = lazy(() => import("src/modules/accounting/cash-deposit/pages/CashDepositList"))
const ProfitCenterList = lazy(() => import("src/modules/accounting/profit-center/pages/ProfitCenterList"))
const CostCenterList = lazy(() => import("src/modules/accounting/cost-center/pages/CostCenterList"))
const Entity = lazy(() => import("src/modules/accounting/entity/pages/EntityList/index.tsx"))
const PaymentTerms = lazy(() => import("src/modules/accounting/PaymentTerms/pages/PaymentTermsList"))
const FiscalYear = lazy(() => import("src/modules/accounting/fiscal-year/pages/FiscalYearList"))
const InvoicePolicyList = lazy(() => import("src/modules/accounting/invoice-policy/pages/InvoicePolicyList"))
const JournalEntry = lazy(() => import("src/modules/accounting/journal-entry/pages/JournalEntryList"))
// const CreateJournalEntry = lazy(() => import("src/modules/accounting/JournalEntry/CreateJournalEntry"))

const ReportsLanding = lazy(() => import("src/modules/accounting/reports/reports-landing"))
const BalanceSheetReport = lazy(() => import("src/modules/accounting/reports/balance-sheet"))
const IncomeStatementReport = lazy(() => import("src/modules/accounting/reports/income-statement"))
const GeneralLedgerReport = lazy(() => import("src/modules/accounting/reports/general-ledger"))
const TrialBalanceReport = lazy(() => import("src/modules/accounting/reports/trial-balance"))

const accountingRoutes = {
  path: "accounting",
  element: <Root />,
  children: [
    {
      index: true,
      element:
        <PermissionRoute permission="accounting:dashboard:view">
          <AccountingHome />
        </PermissionRoute>,

    },
    {
      path: "chart-of-accounts",
      element:
        <PermissionRoute permission="accounting:chart-of-accounts:read">
          <ChartOfAccounts />
        </PermissionRoute>,
    },
    {
      path: "account-subtype",
      element:
        <PermissionRoute permission="accounting:account-subtype:view">
          <AccountSubtype />
        </PermissionRoute>
    },
    // {
    //   path: "fiscal-period",
    //   element: <FiscalPeriod />
    // },

    {
      path: "bank-account",
      element:
        <PermissionRoute permission="accounting:bank-accounts:view">
          <BankAccountList />
        </PermissionRoute>
    },
    {
      path: "asset-class",
      element:
        <PermissionRoute permission="accounting:asset-class:read">
          <AssetClass />
        </PermissionRoute>
    },
    {
      path: "asset-master",
      element:
        <PermissionRoute permission="accounting:asset-master:read">
          <AssetMaster />
        </PermissionRoute>
    },
    {
      path: "source-module",
      element:
        <PermissionRoute permission="accounting:source-module:view">
          <SourceModule />
        </PermissionRoute>
    },
    {
      path: "accounts-receivable",
      element: <AccountsReceivable />
    },
    {
      path: "accounts-payable",
      element: <AccountsPayable />
    },

    {
      path: "cash-account",
      element:
        <PermissionRoute permission="accounting:cash-account:read">
          <CashAccountList />
        </PermissionRoute>
    },
    {
      path: "cash-deposit",
      element:
        <PermissionRoute permission="accounting:cash-deposit:view">
          <CashDepositList />
        </PermissionRoute>
    },
    {
      path: "profit-center",
      element:
        <PermissionRoute permission="accounting:profit-center:read">
          <ProfitCenterList />
        </PermissionRoute>
    },
    {
      path: "cost-center",
      element:
        <PermissionRoute permission="accounting:cost-center:read">
          <CostCenterList />
        </PermissionRoute>
    },
    {
      path: "fiscal-year",
      element:
        <PermissionRoute permission="accounting:fiscal-year:view">
          <FiscalYear />
        </PermissionRoute>
    },
    {
      path: "invoice-policy",
      element:
        <PermissionRoute permission="accounting:invoice-policy:read">
          <InvoicePolicyList />
        </PermissionRoute>
    },
    {
      path: "entity",
      element:
        <PermissionRoute permission="accounting:entity:view">
          <Entity />
        </PermissionRoute>
    },
    {
      path: "payment-terms",
      element:
        <PermissionRoute permission="accounting:payment-terms:view">
          <PaymentTerms />
        </PermissionRoute>
    },
    {
      path: "journal-entry",
      element: <Root />,
      children: [
        {
          index: true,
          element:
            <PermissionRoute permission="accounting:journal-entry:view">
              <JournalEntry />
            </PermissionRoute>
        },
        // {
        //   path: "create",
        //   element: <CreateJournalEntry />
        // }
      ]
    },
    {
      path: "reports",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="accounting:reports:read">
              <ReportsLanding />
            </PermissionRoute>
          )
        },
        {
          path: "balance-sheet",
          element: (
            <PermissionRoute permission="accounting:reports:read">
              <BalanceSheetReport />
            </PermissionRoute>
          )
        },
        {
          path: "income-statement",
          element: (
            <PermissionRoute permission="accounting:reports:read">
              <IncomeStatementReport />
            </PermissionRoute>
          )
        },
        {
          path: "general-ledger",
          element: (
            <PermissionRoute permission="accounting:reports:read">
              <GeneralLedgerReport />
            </PermissionRoute>
          )
        },
        {
          path: "trial-balance",
          element: (
            <PermissionRoute permission="accounting:reports:read">
              <TrialBalanceReport />
            </PermissionRoute>
          )
        }
      ]
    }
  ]
}

export default accountingRoutes

